import script from "./GroupColourModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupColourModal.vue?vue&type=script&setup=true&lang=js"

import "./GroupColourModal.vue?vue&type=style&index=0&id=4e35e1e5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e35e1e5"]])

export default __exports__